import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { clearApiError } from '../../../../app/api/api.actions';
import { apiSelectors } from '../../../../app/api/api.selectors';
import { useRequiredValidation } from '../../../../utils/form/validation.utils';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { FormPasswordInput } from '../../common/inputs/PasswordInput';
import { FormTextInput } from '../../common/inputs/TextInput';
import { IRegisterFormProps } from './types';
import { getUserBrowserTimezoneName } from '../../../../utils/date.utils';
import { getApiErrorMessage } from '../../../../utils/api.utils';

export const SignUpForm: FunctionComponent<IRegisterFormProps> = ({ onSubmit, userInfo }) => {
  const formProps = useForm();
  const setValue = formProps.setValue;

  useEffect(() => {
    if (userInfo) {
      setValue('firstName', userInfo.firstName);
      setValue('lastName', userInfo.lastName);
      setValue('email', userInfo.email);

      setToken(userInfo.token);
    }
  }, [setValue, userInfo]);
  const requiredValidation = useRequiredValidation();

  const dispatch = useDispatch();

  const error = useSelectWithParams(apiSelectors.selectApiError, 'signUpUser');

  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValue('timezone', getUserBrowserTimezoneName());
  }, [setValue]);

  useEffect(() => {
    if (error && !formProps.formState.isSubmitted && formProps.formState.isDirty) {
      dispatch(clearApiError('signUpUser'));
    }
  }, [dispatch, error, formProps.formState.isDirty, formProps.formState.isSubmitted]);

  return (
    <FormProvider {...formProps}>
      <form id="signup-form" onSubmit={formProps.handleSubmit((formData: any) => onSubmit({ ...formData, token }))}>
        <div className="field-container">
          <FormTextInput
            id="firstName"
            name="firstName"
            type="text"
            placeholder="First name"
            validation={requiredValidation}
            disabled={userInfo?.firstName !== undefined}
          />
        </div>
        <div className="field-container">
          <FormTextInput
            id="lastName"
            name="lastName"
            type="text"
            placeholder="Last name"
            validation={requiredValidation}
            disabled={userInfo?.lastName !== undefined}
          />
        </div>
        <div className="field-container">
          <FormTextInput
            id="email"
            name="email"
            type="text"
            placeholder="Email address"
            validation={requiredValidation}
            disabled={userInfo?.email !== undefined}
          />
        </div>
        {userInfo === undefined && (
          <div className="field-container password-field">
            <FormPasswordInput id="password" name="password" placeholder="Password" validation={requiredValidation} />
          </div>
        )}
        <div className="field-container">
          <FormTextInput
            id="companyName"
            name="companyName"
            type="text"
            placeholder="Company name"
            validation={requiredValidation}
          />
        </div>
        <FormTextInput id="timezone" name="timezone" type="hidden" placeholder="Time zone" />
        {error && <label style={{ color: 'red' }}>{getApiErrorMessage(error)}</label>}
      </form>
    </FormProvider>
  );
};
